import { BreadcrumbProps } from 'packages/common-frontend/components/Breadcrumbs';

export const SettingsBreadcrumb: BreadcrumbProps = {
  label: 'Settings',
  path: '/settings',
};

export const SettingsFacilitiesBreadcrumb: BreadcrumbProps = {
  label: 'Facilities',
  path: '/settings/credit-facilities',
};

export const getSettingsPortfolioCovenantsBreadcrumb: (
  creditFacilityId: string,
) => BreadcrumbProps = (creditFacilityId) => {
  return {
    label: 'Portfolio Covenants',
    path: `/settings/credit-facilities/${creditFacilityId}/portfolio-covenants/configuration`,
  };
};
